const mutations = {
  SET_PATIENT_DATA(state, payload) {
    state.patientData = { ...payload };
  },
  SET_PATIENT_REF(state, payload) {
    state.patientData.ref = payload;
  },
  SET_USER_DATA(state, payload) {
    state.userData = {...payload};
  },
};

export default mutations;
